<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <locality-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import LocalityShowData from "./LocalityShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "LocalityShow",
        components: {CrudShow, LocalityShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'maps.locality.showing',
            }
        },
    }
</script>

